import { render, staticRenderFns } from "./view-item.vue?vue&type=template&id=59a04242&scoped=true"
import script from "./view-item.vue?vue&type=script&lang=js"
export * from "./view-item.vue?vue&type=script&lang=js"
import style0 from "./view-item.vue?vue&type=style&index=0&id=59a04242&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a04242",
  null
  
)

export default component.exports